import owd from 'owd/owd';

export default class Contrast extends owd.Component {
	init() {
        this.initContrast();
		this.bind();
	}
    
    initContrast() {
        if(localStorage.getItem('contrast') === 'true')  {
            this.dom.$html.addClass('contrast');
        }
    }

	bind() {
        this.on('click', (e) => {
            e.preventDefault();
            
            this.$element.toggleClass('is-active');
            this.dom.$html.toggleClass('contrast');
            localStorage.setItem('contrast', this.dom.$html.hasClass('contrast'));
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('contrast', {
	component: Contrast
});
